import { FirebaseApp, initializeApp } from "firebase/app";
import { FirebaseOptions } from "firebase/app";
import {
  Firestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";

import { createContext, useContext } from "react";

import { FirestoreRefs } from "./refs";

export interface InitialisedFirebase {
  firebaseApp: FirebaseApp;
  firestore: Firestore;
  firestoreRefs: FirestoreRefs;
}

/**
 * A react hook to initialise Firebase, manages the loading state and any errors
 *
 * @returns
 */
export const createInitialisedFirebase = (
  options: FirebaseOptions
): InitialisedFirebase => {
  const app = initializeApp(options);
  // Listeners replay the IndexedDB copy on mount and then sync only the
  // changes since the last snapshot, instead of downloading every collection
  // on each page load.
  const fs = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });

  return {
    firebaseApp: app,
    firestore: fs,
    firestoreRefs: new FirestoreRefs(fs),
  };
};

export const FirebaseCtx = createContext<InitialisedFirebase>(
  {} as InitialisedFirebase
);

export const useFirebase = (): InitialisedFirebase => {
  return useContext(FirebaseCtx);
};
